import type { TaskExample } from '@frontend/api-types';
import { FlatList, LinkButton, Text, XStack, YStack } from '@frontend/web-react';
import { TrendingTaskCard } from './TrendingTaskCard';

type TrendingTasksContainerProps = {
  examples: TaskExample[];
  layout: 'horizontal' | 'vertical';
};

export const TrendingTasksContainer = ({ examples, layout }: TrendingTasksContainerProps) => {
  return (
    <YStack className="px-md gap-sm">
      <YStack className="gap-xs">
        <XStack className="items-center justify-between">
          <Text type="h4">Trending tasks</Text>
          {layout === 'horizontal' && examples.length > 6 ? (
            <LinkButton
              color="secondary"
              label="See all"
              onClick={() => window.open('https://www.getduckbill.com/directory', '_blank')}
            />
          ) : null}
        </XStack>
        {layout === 'vertical' ? (
          <Text color="secondary" type="p-sm">
            Popular tasks among members
          </Text>
        ) : null}
      </YStack>
      <FlatList
        contentContainerClassName="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
        data={examples.slice(0, 6)}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => <TrendingTaskCard example={item} />}
      />
    </YStack>
  );
};
